/**
 * Link Resolver
 *
 * Resolves URLs for Prismic documents based on their type.
 * Used by:
 * - gatsby-source-prismic for generating page paths
 * - gatsby-plugin-prismic-previews for preview URLs
 * - PrismicProvider for resolving links in content
 *
 * @param {object} doc - Prismic document
 * @returns {string} URL path
 */
exports.linkResolver = doc => {
  switch (doc.type) {
    case "homepage":
      return "/";

    case "about_page":
      return doc.uid ? `/${doc.uid}` : "/about";

    case "top_menu":
    case "footer":
      // These are global components, not pages
      return null;

    default:
      return "/";
  }
};
